module.exports = __webpack_public_path__ + "img/ye-back.b6d0d906.png";